<template>
  <v-progress-circular
    :size="size"
    :color="color"
    :indeterminate="indeterminate"
    v-if="type === 'circular'"
  >
  </v-progress-circular>
  <v-progress-linear
    :height="size"
    :color="color"
    :indeterminate="indeterminate"
    v-else-if="type === 'linear'"
  >
  </v-progress-linear>
</template>

<script>
export default {
  name: "Loader",
  props: {
    type: {
      type: String,
      default: "circular",
    },
    size: {
      type: Number,
      default: 50,
    },
    color: {
      type: String,
      default: "#393939",
    },
    indeterminate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
